import * as React from 'react';
import { Route } from 'react-router-dom';
import { loadScene } from '../../../components/async/scene';

type Props = {};

const oauthSignInScene = loadScene('security', 'OauthSignInScene');

const SecurityRoutes: React.FunctionComponent<Props> = () => {
  return (
    <React.Fragment>
      <Route path={'/oauth/signin'} exact component={oauthSignInScene} />
    </React.Fragment>
  );
};

export default SecurityRoutes;
